import { useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useLocale, seoOverride, applyNotFoundHead, restoreBaselineHead } from "@/lib/LocaleContext";

// Catch-all for unmatched routes: client-side noindex (static host always returns 200).
export default function NotFound() {
  const { t } = useTranslation();
  const { lang } = useLocale();

  useLayoutEffect(() => {
    seoOverride.notFound = true;
    return () => { seoOverride.notFound = false; };
  }, []);

  useEffect(() => {
    applyNotFoundHead(`${t("notFound.title")} | DJ SPY`);
  }, [t, lang]);

  useEffect(() => () => restoreBaselineHead(), []);

  return (
    <div className="min-h-screen bg-black text-white" data-testid="not-found-page">
      <Nav />
      <div className="pt-40 pb-24 px-4 max-w-2xl mx-auto text-center">
        <div className="font-mono text-xs tracking-[0.3em] text-red-brand">// 404</div>
        <h1 className="font-display text-5xl mt-3" data-testid="not-found-title">{t("notFound.title")}</h1>
        <p className="text-white/60 mt-4">{t("notFound.body")}</p>
        <Link to={lang === "ar" ? "/ar" : "/"} className="btn-primary inline-block mt-8" data-testid="not-found-home-link">
          {t("notFound.home")}
        </Link>
      </div>
      <Footer />
    </div>
  );
}
